<template>
  <label
    class="base-switch"
    :class="{
      'base-switch--disabled': disabled,
      'base-switch--loading': loading,
      'base-switch--center': center,
    }"
  >
    <input
      v-model="checked"
      type="checkbox"
      class="base-switch__input"
      :disabled="disabled || loading"
    />
    <span class="base-switch__text-before">
      <slot name="before" />
    </span>
    <span
      class="base-switch__button"
      :class="{ 'base-switch__button--checked': checked }"
    />
    <span class="base-switch__text-after">
      <slot name="after" />
    </span>
  </label>
</template>

<script>
  export default {
    name: 'BaseSwitch',
    emits: ['update:modelValue'],
    props: {
      modelValue: {
        type: [Boolean, Number],
        default: false,
        validator: (value) => [true, false, 0, 1].includes(value),
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      center: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      checked: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit('update:modelValue', value);
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .base-switch {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    margin: 0;
    width: fit-content;

    &--center {
      margin: 0 auto;
    }

    &__input {
      display: none;
      opacity: 0;
      visibility: hidden;
    }
    &__button {
      position: relative;
      display: flex;
      align-items: center;
      opacity: 1;
      transition: opacity 200ms ease-in-out;

      &::before {
        content: '';
        width: 1.8em;
        height: 0.6em;
        background-color: #a7a9ab52;
        border-radius: 1em;
        margin: 0.3em;
      }
      &::after {
        position: absolute;
        left: 0.2em;
        content: '';
        width: 0.8em;
        height: 0.8em;
        background-color: #a7a9ab;
        border-radius: 100%;

        transition:
          left 200ms ease-in-out,
          background-color 200ms ease-in-out;
      }

      &--checked {
        &::before {
          background-color: #a9dcd6;
        }
        &::after {
          left: 1.4em;
          background-color: #09a684;
          transition:
            left 200ms ease-in-out,
            background-color 200ms ease-in-out;
        }
      }
    }
    &--disabled,
    &--loading {
      cursor: not-allowed;

      .base-switch__button {
        position: relative;
        display: flex;
        align-items: center;
        opacity: 0.5;
        transition: opacity 200ms ease-in-out;
      }
    }
    &__text-before {
      text-align: right;
    }
    &__text-after {
      text-align: left;
    }
  }
</style>
